"use strict";
// tslint:disable:triple-equals
// tslint:disable:no-shadowed-variable
// tslint:disable:max-classes-per-file
/**
 * @file Defines the $dyn.layout namespace
 * @copyright 2016 Microsoft Corporation
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    /** Framework base class for layout */
    var layout;
    (function (layout) {
        /**
         * Enum for layout arrange methods
         */
        var ArrangeMethod;
        (function (ArrangeMethod) {
            ArrangeMethod["horizontalWrap"] = "HorizontalWrap";
            ArrangeMethod["horizontalLeft"] = "Horizontal, flush left";
            ArrangeMethod["horizontalRight"] = "Horizontal, flush right";
            ArrangeMethod["vertical"] = "Vertical";
            ArrangeMethod["none"] = "None";
        })(ArrangeMethod = layout.ArrangeMethod || (layout.ArrangeMethod = {}));
        /**
         * Enum for layout alignment
         */
        var Alignment;
        (function (Alignment) {
            Alignment["top"] = "Top";
            Alignment["bottom"] = "Bottom";
        })(Alignment = layout.Alignment || (layout.Alignment = {}));
        /**
         * Enum for layout provides
         */
        var Providers;
        (function (Providers) {
            Providers["css3flexbox"] = "CSS3Flex";
            Providers["css3grid"] = "CSS3Grid";
        })(Providers = layout.Providers || (layout.Providers = {}));
        /**
         * Enum for layout QTip positions
         */
        var qTipPosition;
        (function (qTipPosition) {
            qTipPosition["topLeft"] = "top left";
            qTipPosition["topCenter"] = "top center";
            qTipPosition["topRight"] = "top right";
            qTipPosition["bottomLeft"] = "bottom left";
            qTipPosition["bottomCenter"] = "bottom center";
            qTipPosition["bottomRight"] = "bottom right";
            qTipPosition["leftTop"] = "left top";
            qTipPosition["leftCenter"] = "left center";
            qTipPosition["leftBottom"] = "left bottom";
            qTipPosition["rightTop"] = "right top";
            qTipPosition["rightCenter"] = "right center";
            qTipPosition["rightBottom"] = "right bottom";
        })(qTipPosition = layout.qTipPosition || (layout.qTipPosition = {}));
        /**
         * The default number of items for LimitHeight columns.
         *
         * @description As this columns setting is only used by one control (app bar groups), it is set statically here.
         * If other controls desire to use this behavior, we need to add an option to the layout binding handler to pass in a non-default LimitHeight value.
         */
        layout._defaultLimitHeight = 3;
        /**
         * Check if the current browser supports css flex or IE-Grid and sets the layout provider accordingly
         * @returns True if browser supports css flex or IE-Grid; otherwise, false.
         */
        function supportsFlexOrGrid() {
            var testDiv = $(window.document.createElement("div"));
            $("body").append(testDiv);
            var flexSupported = false;
            var gridSupported = false;
            $("body").append(testDiv);
            flexSupported = flexSupported || testDiv.css("display", "-webkit-flex").css("display") === "-webkit-flex";
            flexSupported = flexSupported || testDiv.css("display", "-webkit-box").css("display") === "-webkit-box";
            flexSupported = flexSupported || testDiv.css("display", "flex").css("display") === "flex";
            gridSupported = testDiv.css("display", "-ms-grid").css("display") === "-ms-grid";
            // window.CSS.supports method is implemented for Spartan, but not previous versions of IE.
            // This is meant enable Flex for the Spartan browser specifically.
            // We will continue using the method above to detect if flex is supported in most cases as window.CSS.supports is not supported in Safari.
            flexSupported = gridSupported ? window.CSS && window.CSS.supports && window.CSS.supports("display", "flex") : flexSupported;
            testDiv.remove();
            if ($dyn.debug.layoutFlex || flexSupported) {
                $("body").addClass($dyn.layout.Providers.css3flexbox);
                $dyn.layout.provider = new $dyn.layout.css3flexbox($dyn.layout.provider);
            }
            else if (gridSupported) {
                $("body").addClass($dyn.layout.Providers.css3grid);
                $dyn.layout.provider = new $dyn.layout.css3grid($dyn.layout.provider);
            }
            return flexSupported || gridSupported;
        }
        layout.supportsFlexOrGrid = supportsFlexOrGrid;
        /**
         * Enum for layout size.
         */
        var Size;
        (function (Size) {
            /** Used in the control height or width to constrain the control to size to its parent available space */
            Size["available"] = "SizeToAvailable";
            /** Used in the control height or width to allow the control to size to its content */
            Size["content"] = "SizeToContent";
            /** Used in the control height or width to allow the control to have fixed size */
            Size["fixed"] = "fixed";
            /** Used in the control height or width to allow the control to have discrete size xsmall */
            Size["xsmall"] = "xsmall";
            /** Used in the control height or width to allow the control to have discrete size small */
            Size["small"] = "small";
            /** Used in the control height or width to allow the control to have discrete size medium */
            Size["medium"] = "medium";
            /** Used in the control height or width to allow the control to have discrete size large */
            Size["large"] = "large";
        })(Size = layout.Size || (layout.Size = {}));
        /**
         * Enum for layout columns.
         */
        var Columns;
        (function (Columns) {
            Columns["fill"] = "Fill";
            Columns["balanced"] = "Balanced";
            Columns["limitHeight"] = "LimitHeight";
        })(Columns = layout.Columns || (layout.Columns = {}));
        /** CSS class name should be used when the element is a reflow scope, but can also have size which needs to be assigned by its parent container, such as a tab container. */
        layout.ScopeMarker = "layout-reflow-scope";
        /**
         * CSS class name should be used when the element is entirely independent.
         * It is absolutely/relatively positioned, and does not use the sizing handler to get a size assigned by its parent.
         */
        layout.RootScopeMarker = "layout-root-scope";
        /**
         * Return container element assiged to target element
         * @returns Container element assiged to target element
         */
        function layoutContainer(targetElement) {
            var layoutContainer;
            if (targetElement) {
                var container = targetElement.dynLayoutContainer;
                layoutContainer = container ? container : targetElement;
            }
            return layoutContainer;
        }
        layout.layoutContainer = layoutContainer;
        /**
         * Get the options for the given breakable groups binding handler.
         * @description These are the properties that the broken groups will be dependent on the original group for.
         * @remarks Add a property to this list its binding handler can/should be called on the broken group elements.
         * @param $data The group for the binding handler.
         * @returns An object containing the values for the visible, extended, and extendedStyle properties on the handler.
         */
        function breakableGroupsOptions($data) {
            return {
                enabled: $data.Enabled,
                extendedStyle: $data.Style,
                visible: $data.Visible,
            };
        }
        layout.breakableGroupsOptions = breakableGroupsOptions;
        /**
         * Returns a $dyn.options representing the container properties.
         */
        function containerBinding($data) {
            return $dyn.options(function () {
                return {
                    arrangeMethod: $data.LayoutArrangeMethod,
                    children: $data.Children,
                    columns: $data.LayoutColumns,
                };
            }, $data.Updating);
        }
        layout.containerBinding = containerBinding;
        /** The event to trigger after layout reflow is completed */
        layout.layoutCompleteEvent = "layoutComplete";
    })(layout = $dyn.layout || ($dyn.layout = {}));
    var bindingHandlers;
    (function (bindingHandlers) {
        /**
         * Binding handler to invoke layout complete event
         * @internal
         */
        // TODO TFS:3745038 Move to html-binding-handlers
        bindingHandlers.layoutCompleted = function () {
            var callBack = null;
            return {
                apply: function (options) {
                    callBack = options;
                    $(document.body).on($dyn.layout.layoutCompleteEvent, callBack);
                },
                dispose: function () {
                    if (callBack) {
                        $(document.body).off($dyn.layout.layoutCompleteEvent, callBack);
                    }
                },
            };
        };
        /**
         * Binding handler for marking an element as breakable.
         * @internal
         */
        var BreakableBindingHandler = /** @class */ (function () {
            function BreakableBindingHandler() {
            }
            BreakableBindingHandler.prototype.invoke = function (targetElement, breakable) {
                targetElement.dynIsBreakable = breakable;
            };
            BreakableBindingHandler.prototype.dispose = function (targetElement) {
                targetElement.dynIsBreakable = undefined;
            };
            return BreakableBindingHandler;
        }());
        bindingHandlers.breakable = new BreakableBindingHandler();
        /**
         * Binding handler for the dependent properties that should be copied to the layout-breakable-group elements.
         * @internal
         */
        var BreakableGroupsBindingHandler = /** @class */ (function () {
            function BreakableGroupsBindingHandler() {
            }
            BreakableGroupsBindingHandler.prototype.invoke = function (targetElement, options) {
                if (targetElement.dynIsBreakable) {
                    // Options must be in the format of { bindingHandlerName: PropertyValue, ... }
                    $dyn.layout.copyBreakableGroupProperties(options, targetElement);
                }
            };
            return BreakableGroupsBindingHandler;
        }());
        bindingHandlers.breakableGroups = new BreakableGroupsBindingHandler();
    })(bindingHandlers = $dyn.bindingHandlers || ($dyn.bindingHandlers = {}));
    (function (layout) {
        /**
         * Helper function to copy a set of properties to groups that have been split. options must be in the format of { <bindingHandlerName>: <PropertyValue>, ... }
         * The function will call the binding handlers for each of these properties with the given value passed to the apply.
         * @private
         */
        function copyBreakableGroupProperties(options, targetElement) {
            var childGroups = targetElement.dynBreakableGroups;
            if (childGroups && childGroups.length > 0) {
                // If the group has been broken up, update dependent properties on the split groups
                $.each(childGroups, function (index, element) {
                    if (options) {
                        $.each(options, function (key, value) {
                            if (key === "visible") {
                                $dyn.util.setVisibility(element, $dyn.value(options.visible));
                            }
                            else {
                                $dyn._invokeHandler(key, element, value);
                            }
                        });
                    }
                });
            }
        }
        layout.copyBreakableGroupProperties = copyBreakableGroupProperties;
        /**
         * Generates layout sizing object based on Width and Height properties of the control.
         *
         * @param control Control data context
         * @param minFlexWidth
         * @param minFlexHeight
         * @param heightOverride Observable that get toggled when the height of the control gets overridden in the arrange,
         *  elements can handle this behavior and resize their internal contents accordingly.
         * @param widthOverride Observable that get toggled when the width of the control gets overridden in the arrange,
         *  elements can handle this behavior and resize their internal contents accordingly.
         * @returns Returns sizing object
         */
        function sizing(control, minFlexWidth, minFlexHeight, heightOverride, widthOverride) {
            return {
                width: control.LayoutWidth,
                // tslint:disable:object-literal-sort-keys
                height: control.LayoutHeight,
                minFlexWidth: minFlexWidth,
                minFlexHeight: minFlexHeight,
                heightOverride: heightOverride,
                widthOverride: widthOverride,
            };
        }
        layout.sizing = sizing;
        (function (sizing) {
            /**
             * Determines whether or not the provided string is a discrete size such as xsmall, small, medium and large.
             * Options for sizing based on Width and Height properties.
             * @param value The size value string.
             * @returns True if the value represents a discrete size; otherwise, false.
             */
            function isDiscreteSize(value) {
                return value !== $dyn.layout.Size.available && value !== $dyn.layout.Size.content && value !== $dyn.ui.autoValue && value !== "undefined" && !!value;
            }
            sizing.isDiscreteSize = isDiscreteSize;
        })(sizing = layout.sizing || (layout.sizing = {}));
    })(layout = $dyn.layout || ($dyn.layout = {}));
    (function (bindingHandlers) {
        var SizingBindingHandler = /** @class */ (function () {
            function SizingBindingHandler() {
            }
            SizingBindingHandler.prototype.setup = function (targetElement, initialValue) {
                var _this = this;
                // TODO Use skipFirstTimeFire
                var firstTime = true;
                var state = {};
                state.widthObserver = $dyn.observe(initialValue.width, function (value) {
                    if (!firstTime) {
                        _this.widthChanged(targetElement, value);
                        $dyn.layout.queueArrange(targetElement.parentNode);
                    }
                }, this);
                state.heightObserver = $dyn.observe(initialValue.height, function (value) {
                    if (!firstTime) {
                        _this.heightChanged(targetElement, value);
                        $dyn.layout.queueArrange(targetElement.parentNode);
                    }
                }, this);
                firstTime = false;
                targetElement.dynMinFlexWidth = initialValue.minFlexWidth;
                targetElement.dynWidthOverride = initialValue.widthOverride;
                targetElement.dynMinFlexHeight = initialValue.minFlexHeight;
                targetElement.dynHeightOverride = initialValue.heightOverride;
                targetElement.dynLayoutIgnoreSiblings = initialValue.ignoreSiblings;
                return state;
            };
            SizingBindingHandler.prototype.shouldInvoke = function (newValue, oldValue) {
                if (newValue === oldValue) {
                    $dyn.logError("sizing handler does not support passing the same complex object, or no object at all.");
                }
                // Unwrap the observables so that they are basic primitives. We do this so that the next time when this handler
                // is invoked the 'oldValue' has simple primitives which correctly represent that previous values.
                newValue.width = $dyn.peek(newValue.width);
                newValue.height = $dyn.peek(newValue.height);
                newValue.minFlexHeight = $dyn.peek(newValue.minFlexHeight);
                newValue.minFlexWidth = $dyn.peek(newValue.minFlexWidth);
                return (!oldValue ||
                    newValue.width !== oldValue.width ||
                    newValue.height !== oldValue.height ||
                    newValue.minFlexHeight !== oldValue.minFlexHeight ||
                    newValue.minFlexWidth !== oldValue.minFlexWidth);
            };
            SizingBindingHandler.prototype.invoke = function (targetElement, newValue, oldValue) {
                this.widthChanged(targetElement, newValue.width, newValue.minFlexWidth);
                this.heightChanged(targetElement, newValue.height, newValue.minFlexHeight);
                $dyn.layout.queueArrange(targetElement.parentNode);
            };
            SizingBindingHandler.prototype.dispose = function (targetElement, state) {
                targetElement.dynLayoutIgnoreSiblings = undefined;
                targetElement.dynPreferredWidth = undefined;
                targetElement.dynMinFlexWidth = undefined;
                targetElement.dynWidthOverride = undefined;
                targetElement.dynPreferredHeight = undefined;
                targetElement.dynMinFlexHeight = undefined;
                targetElement.dynHeightOverride = undefined;
                if (state.widthObserver) {
                    state.widthObserver.dispose();
                    this.removeSize(targetElement, "width");
                }
                if (state.heightObserver) {
                    state.heightObserver.dispose();
                    this.removeSize(targetElement, "height");
                }
            };
            SizingBindingHandler.prototype.widthChanged = function (element, width, minFlexWidth) {
                element.dynPreferredWidth = width;
                this.applySize(element, width, "width");
                element.dynMinFlexWidth = minFlexWidth;
                // Note: IE grid layout fails if a min width or height is set and the element is statically sized in that dimension.
                if (minFlexWidth !== undefined && element.dynIsStaticallySized) {
                    element.dynMinFlexWidth = undefined;
                }
            };
            SizingBindingHandler.prototype.heightChanged = function (element, height, minFlexHeight) {
                element.dynPreferredHeight = height;
                this.applySize(element, height, "height");
                element.dynMinFlexHeight = minFlexHeight;
                // Note: IE grid layout fails if a min width or height is set and the element is statically sized in that dimension.
                if (minFlexHeight !== undefined && element.dynIsStaticallySized) {
                    element.dynMinFlexHeight = undefined;
                }
            };
            SizingBindingHandler.prototype.applySize = function (element, value, axis) {
                element.dynIsStaticallySized = false;
                element.removeAttribute(axis);
                if (axis === "width") {
                    element.style.width = "";
                    element.style.minWidth = "";
                }
                else {
                    element.style.height = "";
                }
                var target = $(element);
                // tslint:disable-next-line:radix
                var integer = parseInt(value);
                // We should remove the discrete size classes in any case.
                this.resetDiscreteSizeClasses(element, axis);
                if (isNaN(integer)) {
                    if ($dyn.layout.sizing.isDiscreteSize(value)) {
                        element.classList.add("hasdiscretesize-" + axis);
                        element.classList.add("discretesize-" + axis + "-" + value);
                        axis === "width" ? $dyn.layout.provider.setFixedWidth(element) : $dyn.layout.provider.setFixedHeight(element);
                        axis === "width" ? $dyn.layout.provider.removeFillWidth(element) : $dyn.layout.provider.removeFillHeight(element);
                    }
                    else {
                        var hasFixed = element.classList.contains("fixed-" + axis);
                        if (hasFixed) {
                            axis === "width" ? $dyn.layout.provider.removeFixedWidth(element) : $dyn.layout.provider.removeFixedHeight(element);
                        }
                    }
                }
                else {
                    var integerPixels = integer + "px";
                    element.dynIsStaticallySized = true;
                    // The provided value is an integer. Assume units of pixels and assign a fixed size.
                    if (axis === "width") {
                        $dyn.layout.provider.setFixedWidth(element);
                        // Previously added flex attributes should be removed
                        $dyn.layout.provider.removeFillWidth(element);
                        target[0].style.width = integerPixels;
                        // Min width is need for layout such table that when the available space can cause an element to take less width than the given width
                        target[0].style.minWidth = integerPixels;
                    }
                    else {
                        $dyn.layout.provider.setFixedHeight(element);
                        // Previously added flex attributes should be removed
                        $dyn.layout.provider.removeFillHeight(element);
                        target[0].style.height = integerPixels;
                    }
                }
            };
            SizingBindingHandler.prototype.removeSize = function (element, axis) {
                element.removeAttribute(axis);
                if (axis === "width") {
                    element.style.width = "";
                    element.style.minWidth = "";
                }
                else {
                    element.style.height = "";
                }
                this.resetDiscreteSizeClasses(element, axis);
                var hasFixed = element.classList.contains("fixed-" + axis);
                if (hasFixed) {
                    axis === "width" ? $dyn.layout.provider.removeFixedWidth(element) : $dyn.layout.provider.removeFixedHeight(element);
                }
            };
            SizingBindingHandler.prototype.resetDiscreteSizeClasses = function (element, axis) {
                // Ideally, we should detect the classes here and remove only what is needed to reduce the amount of DOM manipulation.
                element.classList.remove("hasdiscretesize-" + axis);
                element.classList.remove("discretesize-" + axis + "-large");
                element.classList.remove("discretesize-" + axis + "-medium");
                element.classList.remove("discretesize-" + axis + "-small");
                element.classList.remove("discretesize-" + axis + "-xsmall");
                element.classList.remove("discretesize-" + axis + "-fixed");
            };
            return SizingBindingHandler;
        }());
        bindingHandlers.sizing = new SizingBindingHandler();
        /** Binding handler for using dynamic sizing behavior where the height/width can only increase when using SizeToContent, never decrease. */
        var DynamicSizingBindingHandler = /** @class */ (function () {
            function DynamicSizingBindingHandler() {
            }
            DynamicSizingBindingHandler.prototype.shouldInvoke = function (newValue, oldValue) {
                return !oldValue || newValue.height !== oldValue.height || newValue.width !== oldValue.width;
            };
            DynamicSizingBindingHandler.prototype.invoke = function (targetElement, options) {
                targetElement.dynIncreasingHeight = options.height;
                targetElement.dynIncreasingWidth = options.width;
            };
            DynamicSizingBindingHandler.prototype.dispose = function (targetElement) {
                // need to dispose of the local attributes set on the targetElement
                targetElement.dynIncreasingHeight = undefined;
                targetElement.dynIncreasingWidth = undefined;
            };
            return DynamicSizingBindingHandler;
        }());
        bindingHandlers.dynamicSizing = new DynamicSizingBindingHandler();
    })(bindingHandlers = $dyn.bindingHandlers || ($dyn.bindingHandlers = {}));
    (function (layout) {
        /**
         * Return the min-width for the element that requested it given the CSS class that contains the corresponding CSS min-width.
         * @description This is needed specifically so we can specify the row height for the grid layout in IE, so if we ever move away from that, this code can be removed.
         * @returns Returns the actual size of the grid in the DOM
         */
        function gridLayoutMinWidth(cssClass, target) {
            return $dyn.layout._retrieveGridLayoutMin(cssClass, target, "width", ["left", "right"]);
        }
        layout.gridLayoutMinWidth = gridLayoutMinWidth;
        /**
         * Return the min-height for the element that requested it given the CSS class that contains the corresponding CSS min-height.
         * @description This is needed specifically so we can specify the row height for the grid layout in IE, so if we ever move away from that, this code can be removed.
         * @returns Returns the actual size of the grid in the DOM
         */
        function gridLayoutMinHeight(cssClass, target) {
            return $dyn.layout._retrieveGridLayoutMin(cssClass, target, "height", ["top", "bottom"]);
        }
        layout.gridLayoutMinHeight = gridLayoutMinHeight;
        /**
         * Retrieve the grid layout template element from the DOM and request the min-height and min-width for each control type,
         * which will be used to set min-height and width on rows for the IE grid layout.
         *
         * @param cssClass The CSS class of the element to retrieve
         * @param target The target element to retrieve the mins from.
         * @param dimension The dimension (height or width).
         * @param margin The margins to retrieve (top/bottom or left/right)
         * @returns Grid size in pixel
         */
        function _retrieveGridLayoutMin(cssClass, target, dimension, margin) {
            if (!$dyn.layout.gridLayoutMinSizes) {
                $dyn.layout.gridLayoutMinSizes = {};
            }
            // Need to store the values for each density
            var densityKey = $dyn.densityThemeManager._getCurrentDensity().toString();
            var densityObject = $dyn.layout.gridLayoutMinSizes[densityKey];
            if (!densityObject) {
                densityObject = $dyn.layout.gridLayoutMinSizes[densityKey] = {};
            }
            // Store the values for each container type
            var containerSizeObject = densityObject[cssClass];
            if (!containerSizeObject) {
                containerSizeObject = densityObject[cssClass] = {};
            }
            var containerSize = containerSizeObject[dimension];
            if (!containerSize) {
                var $ieGridTemplate = $(document.createElement("div"));
                var $innerElement = $(document.createElement("div"));
                $innerElement.addClass(cssClass);
                $innerElement.addClass("layout-container");
                $innerElement.addClass("fill-" + dimension);
                $innerElement.hide();
                $ieGridTemplate.append($innerElement);
                $ieGridTemplate.addClass("layout-container");
                $(target).append($ieGridTemplate);
                // Store the margins and dimension into the collection element so we only have to retrieve them once for each control type
                var $targetMinElement = $($ieGridTemplate.children($dyn.format(".{0}", cssClass))[0]);
                // tslint:disable-next-line:radix
                $dyn.layout.gridLayoutMinSizes[densityKey][cssClass][dimension] = parseInt($targetMinElement.css($dyn.format("min-{0}", dimension)));
                var mgn1 = $targetMinElement.css($dyn.format("margin-{0}", margin[0]));
                var mgn2 = $targetMinElement.css($dyn.format("margin-{0}", margin[1]));
                // tslint:disable-next-line:radix
                $dyn.layout.gridLayoutMinSizes[densityKey][cssClass][margin[0]] = parseInt(mgn1) + parseInt(mgn2);
                $ieGridTemplate.detach();
            }
            return $dyn.format("{0}px", $dyn.layout.gridLayoutMinSizes[densityKey][cssClass][dimension] + $dyn.layout.gridLayoutMinSizes[densityKey][cssClass][margin[0]]);
        }
        layout._retrieveGridLayoutMin = _retrieveGridLayoutMin;
    })(layout = $dyn.layout || ($dyn.layout = {}));
    (function (bindingHandlers) {
        /**
         * Layout binding handler for ArrangeMethod, Columns, and Alignment
         * @internal
         */
        // TODO TFS:3745038 Move to html-binding-handlers
        var LayoutBindingHandler = /** @class */ (function () {
            function LayoutBindingHandler() {
            }
            LayoutBindingHandler.prototype.shouldInvoke = function (newValue, oldValue) {
                return !oldValue || newValue.arrangeMethod !== oldValue.arrangeMethod || newValue.columns !== oldValue.columns || !this.compareChildren(newValue.children, oldValue.children);
            };
            LayoutBindingHandler.prototype.invoke = function (targetElement, options) {
                var arrangeMethod = $dyn.value(options.arrangeMethod) || $dyn.ui.autoValue;
                if (arrangeMethod != $dyn.layout.ArrangeMethod.none) {
                    var columns = $dyn.value(options.columns) || 1;
                    if (arrangeMethod === $dyn.ui.autoValue) {
                        arrangeMethod = $dyn.layout.ArrangeMethod.vertical;
                    }
                    var alignment = $dyn.value(options.alignment) || $dyn.layout.Alignment.bottom;
                    targetElement.dynColumns = columns;
                    targetElement.dynAlignment = alignment;
                }
                targetElement.dynArrangeMethod = arrangeMethod;
                $dyn.layout.queueArrange(targetElement);
            };
            LayoutBindingHandler.prototype.dispose = function (targetElement) {
                // need to dispose of the local attributes set on the targetElement
                targetElement.dynArrangeMethod = undefined;
                targetElement.dynColumns = undefined;
                targetElement.dynAlignment = undefined;
            };
            LayoutBindingHandler.prototype.compareChildren = function (array1, array2) {
                if (array1 === array2) {
                    return true;
                }
                if (!array1 || !array2) {
                    return false;
                }
                if (array1.length !== array2.length) {
                    return false;
                }
                for (var i = 0; i < array1.length; i++) {
                    if (array1[i] !== array2[i]) {
                        return false;
                    }
                }
                return true;
            };
            return LayoutBindingHandler;
        }());
        bindingHandlers.layout = new LayoutBindingHandler();
    })(bindingHandlers = $dyn.bindingHandlers || ($dyn.bindingHandlers = {}));
    (function (layout) {
        /**
         * Reflow scopes and top level elements that correspond to each.
         * Each reflow scope will be mapped to its corresponding top arrange element according to the index in the array
         */
        layout.topArrangeElements = { scopes: [], elements: [] };
        /** marked while in $dyn.layout.arrange or $dyn.layout.reflow functions */
        layout.inArrangeOrReflow = false;
        /** A collection of top level elements that need to be reflowed. */
        layout.reflowElements = $([]);
        layout.endReflowHandlers = {};
        layout.startReflowHandlers = {};
        /** An id, being assigned to reflow scope */
        layout._reflowScopeId = 1;
        /** An id being assigned to reflow scope handler */
        layout._reflowScopeHandlerId = 1;
        /**
         * Registers layout reflow handler on a given element.
         * @description The handler is going to be invoked at the end of reflow operation for one of the reflow parents of a given element.
         *
         * @param targetElement The element that we are subscribing to
         * @param handler The handler of end reflow event
         * @returns Return an object with dispose method to dispose the handler.
         */
        function registerEndReflowHandler(targetElement, handler) {
            return $dyn.layout._registerReflowHandler(targetElement, handler, $dyn.layout.endReflowHandlers);
        }
        layout.registerEndReflowHandler = registerEndReflowHandler;
        /**
         * Registers layout reflow handler on a given element.
         * @description The handler is going to be invoked at the start of reflow operation for one of the reflow parents of a given element
         *
         * @param targetElement The element that we are subscribing to
         * @param handler The handler of end reflow event
         * @returns Return an object with dispose method to dispose the handler.
         */
        function registerStartReflowHandler(targetElement, handler) {
            return $dyn.layout._registerReflowHandler(targetElement, handler, $dyn.layout.startReflowHandlers);
        }
        layout.registerStartReflowHandler = registerStartReflowHandler;
        /**
         * Registers layout reflow handler on a given element
         *
         * @param targetElement The element that we are subscribing to
         * @param handler The handler of the reflow event
         * @param reflowHandlers Mapping of reflow event handlers
         * @returns Return an object with dispose method to dispose the handler.
         */
        function _registerReflowHandler(targetElement, handler, reflowHandlers) {
            var $closestScope = $(targetElement).closest($dyn.format(".{0},.{1}", $dyn.layout.ScopeMarker, $dyn.layout.RootScopeMarker));
            var $reflowScopes = $closestScope.parents($dyn.format(".{0},.{1}", $dyn.layout.ScopeMarker, $dyn.layout.RootScopeMarker));
            if ($closestScope && $reflowScopes) {
                $reflowScopes = $reflowScopes.add($closestScope);
                var handlerId_1 = $dyn.layout._reflowScopeHandlerId++;
                // tslint:disable-next-line:prefer-for-of
                for (var i = 0; i < $reflowScopes.length; ++i) {
                    var scopeElement = $reflowScopes[i];
                    if (scopeElement.dynReflowScopeId === undefined) {
                        scopeElement.dynReflowScopeId = $dyn.layout._reflowScopeId;
                        $dyn.layout._reflowScopeId++;
                    }
                    if (!reflowHandlers[scopeElement.dynReflowScopeId]) {
                        reflowHandlers[scopeElement.dynReflowScopeId] = {};
                    }
                    reflowHandlers[scopeElement.dynReflowScopeId][handlerId_1] = handler;
                }
                return {
                    dispose: function () {
                        // tslint:disable-next-line:prefer-for-of
                        for (var i = 0; i < $reflowScopes.length; ++i) {
                            var scopeElement = $reflowScopes[i];
                            if (scopeElement.dynReflowScopeId !== undefined) {
                                var scopeHandlers = reflowHandlers[scopeElement.dynReflowScopeId];
                                if (scopeHandlers) {
                                    delete scopeHandlers[handlerId_1];
                                    if (Object.keys(scopeHandlers).length === 0) {
                                        delete reflowHandlers[scopeElement.dynReflowScopeId];
                                    }
                                }
                            }
                        }
                    },
                };
            }
        }
        layout._registerReflowHandler = _registerReflowHandler;
        function _notifyReflowHandlers(reflowElements, reflowHandler) {
            var elements = $(reflowElements);
            // tslint:disable-next-line:prefer-for-of
            for (var i = 0; i < elements.length; ++i) {
                var element = elements[i];
                var reflowScopeMarkerId = element.dynReflowScopeId;
                if (reflowScopeMarkerId !== undefined) {
                    var handlers = reflowHandler[reflowScopeMarkerId];
                    if (handlers) {
                        var keys = Object.keys(handlers);
                        // tslint:disable-next-line:prefer-for-of
                        for (var j = 0; j < keys.length; ++j) {
                            if (handlers[keys[j]]) {
                                handlers[keys[j]](element);
                            }
                        }
                    }
                }
            }
        }
        layout._notifyReflowHandlers = _notifyReflowHandlers;
        /**
         * Registers layout reflow handler on a given element
         * @internal
         * @param element The element to look inside including itself
         * @returns Return the first reflow scope within the element
         */
        function getFirstReflowElement(element) {
            var $element = $(element);
            var selector = $dyn.format(".{0},.{1}", $dyn.layout.ScopeMarker, $dyn.layout.RootScopeMarker);
            return $element.find(selector).addBack(selector).first()[0];
        }
        layout.getFirstReflowElement = getFirstReflowElement;
        /**
         * Subscribes the arrangeTopLevelElement function to when the $dyn.ui.layout flag flips.
         *
         * @returns Returns subscription ID
         */
        function subscribeArrangeToLayout() {
            // We should prevent loops in processing top level arranges
            var processingPendingArrange;
            return $dyn.observe($dyn.ui.layout, function processPendingArrange() {
                if (!$dyn.value($dyn.ui.layout) && !processingPendingArrange) {
                    processingPendingArrange = true;
                    $dyn.layout.arrangeTopLevelElement();
                    processingPendingArrange = false;
                }
            });
        }
        layout.subscribeArrangeToLayout = subscribeArrangeToLayout;
        /**
         * Reflow the current root form and the open dialogs.
         * @internal
         */
        function reflowRootForm() {
            var rootFormElement = $dyn.shell.getCurrentRootForm();
            var rootForm = $dyn.context(rootFormElement);
            if (rootFormElement && rootForm) {
                $dyn.layout.reflow(rootFormElement, true);
                var dialogStack = $dyn.value(rootForm.dialogStack);
                for (var i = 0; i < $dyn.length(dialogStack); i++) {
                    var context_1 = $dyn.context($dyn.value(dialogStack)[i]);
                    if (context_1 && context_1.element) {
                        $dyn.layout.reflow(context_1.element, true);
                    }
                }
            }
            // if Aside pane is open also reflow it
            rootFormElement = $dyn.shell.getActiveAsideForm();
            rootForm = $dyn.context(rootFormElement);
            if ($dyn.value($dyn.shell.isAsidePaneOpen)) {
                if (rootFormElement && rootForm) {
                    $dyn.layout.reflow(rootFormElement, true);
                }
            }
        }
        layout.reflowRootForm = reflowRootForm;
        layout._arrangeTopLevelElement = $dyn.debug.performance ? new $dyn.DomPerformanceTask("arrangeTopLevelElement") : null;
        /**
         * Calls arrange on each top level element corresponding to each reflow-scope element, and reflows all of the elements that need it.
         * @private
         */
        function arrangeTopLevelElement() {
            if ($dyn.layout.topArrangeElements.elements.length) {
                var oldValue = $dyn.shell.bodyFocusCorrection;
                // Arrange all of the top level elements for each reflow scope
                // tslint:disable-next-line:prefer-for-of
                for (var i = 0; i < $dyn.layout.topArrangeElements.elements.length; i++) {
                    var $topArrangeElement = $($dyn.layout.topArrangeElements.elements[i]);
                    $dyn.layout._arrangeTopLevelElement && $dyn.layout._arrangeTopLevelElement.start($topArrangeElement[0]);
                    $dyn.layout.arrange($dyn.layout.topArrangeElements.elements[i], false, true);
                    $dyn.layout._arrangeTopLevelElement && $dyn.layout._arrangeTopLevelElement.stop($topArrangeElement[0]);
                }
                $dyn.layout.topArrangeElements.scopes = [];
                $dyn.layout.topArrangeElements.elements = [];
                if ($dyn.layout._originalActiveElement) {
                    $dyn.ui.restoreFocus($dyn.layout._originalActiveElement);
                    $dyn.layout._originalActiveElement = undefined;
                    $dyn.shell.bodyFocusCorrection = oldValue;
                }
            }
            if ($dyn.layout.reflowElements.length) {
                // Drain the queue of reflow elements
                $dyn.layout.reflow($dyn.layout.reflowElements);
                $dyn.layout.reflowElements = $([]);
                $(document.body).trigger($dyn.layout.layoutCompleteEvent);
            }
        }
        layout.arrangeTopLevelElement = arrangeTopLevelElement;
        /**
         * Queue a reflow on a given element finding its nearest reflow-scope marker element.
         * @private
         * @param reflowElement The element from which to search for the nearest layout-reflow-scope marker.
         */
        function queueReflow(reflowElement) {
            var scopeElement = $(reflowElement).closest($dyn.format(".{0},.{1}", $dyn.layout.ScopeMarker, $dyn.layout.RootScopeMarker));
            if (!$dyn.layout.reflowElements.length || (!$dyn.layout.reflowElements.filter(scopeElement).length && !$dyn.layout.reflowElements.find(scopeElement).length)) {
                $dyn.layout.reflowElements = $dyn.layout.reflowElements.add(scopeElement);
            }
        }
        layout.queueReflow = queueReflow;
        /**
         * Add an element to layout arrange queue
         * @param layoutCandidate The element to be arranged.
         */
        function queueArrange(layoutCandidate) {
            /// If in an updating block, checks whether the element passed in is the topmost layout element on the page checking
            /// the intersection of it and the current top level element.
            // For optimization don't actually perform an arrange unless that parent has arranged this child before, which will happen once when the root element on the form is laid out.
            // (Assume the parent will eventually arrange its children which will then take care of this object as well.)
            if ($dyn.layout.inArrangeOrReflow) {
                // Return immediately if we are in an arrange or reflow. No need to determine which candidate to be queued.
                return;
            }
            if (layoutCandidate && layoutCandidate.dynHasArranged) {
                if (layoutCandidate.classList) {
                    // First, check the parent of the candidate. If it has the dynIsBreakable attribute, we should go two levels higher to the layout-column so the group gets re-broken during arrange.
                    var layoutCandidateParent = $(layoutCandidate).parent();
                    if (layoutCandidateParent[0] && layoutCandidateParent[0].dynIsBreakable) {
                        layoutCandidate = layoutCandidate.parentNode.parentNode;
                    }
                    // If the layout candidate has the class 'layout-breakable-group', the parent node should be the candidate so the breakable groups get recreated accordingly
                    if (layoutCandidate && layoutCandidate.classList && layoutCandidate.classList.contains("layout-breakable-group")) {
                        layoutCandidate = layoutCandidate.parentNode;
                    }
                    // If the parent is a layout-column, go one level higher so that the layout-columns get regenerated if needed.
                    if (layoutCandidate && layoutCandidate.classList && layoutCandidate.classList.contains("layout-column")) {
                        layoutCandidate = layoutCandidate.parentNode;
                    }
                }
                // Arrange the element or see if it should be the top level layout element
                if (layoutCandidate) {
                    if ($dyn.value($dyn.ui.layout)) {
                        // Look for the candidates reflow scope marker and look for its index in the collection
                        var nearestReflowScope = $(layoutCandidate).closest($dyn.format(".{0},.{1}", $dyn.layout.ScopeMarker, $dyn.layout.RootScopeMarker));
                        if (nearestReflowScope.length) {
                            var index = $dyn.layout.topArrangeElements.scopes.indexOf(nearestReflowScope[0]);
                            if (index < 0) {
                                $dyn.layout.topArrangeElements.scopes.push(nearestReflowScope[0]);
                                $dyn.layout.topArrangeElements.elements.push(layoutCandidate);
                                $dyn.layout.queueReflow(nearestReflowScope);
                            }
                            else {
                                // The top arrange element for this reflow scope is stored in the corresponding index
                                var topArrangeElement = $dyn.layout.topArrangeElements.elements[index];
                                if (layoutCandidate != topArrangeElement) {
                                    var invalidTopArrangeElement = false;
                                    var currentArrangeElementParents = $(topArrangeElement).parents().addBack();
                                    if (!$(currentArrangeElementParents[0]).is("html")) {
                                        // the topArrangeElement is not in the DOM anymore
                                        invalidTopArrangeElement = true;
                                    }
                                    var invalidLayoutCandidate = false;
                                    var candidateParents = $(layoutCandidate).parents().addBack();
                                    if (!$(candidateParents[0]).is("html")) {
                                        // the layoutCandidate is not in the DOM anymore
                                        invalidLayoutCandidate = true;
                                    }
                                    if (invalidTopArrangeElement && invalidLayoutCandidate) {
                                        // If both topArrangeElement and layoutCandidate are not in the DOM then delete the element and scope from the queue
                                        $dyn.layout.topArrangeElements.scopes.splice(index, 1);
                                        $dyn.layout.topArrangeElements.elements.splice(index, 1);
                                    }
                                    else if (invalidTopArrangeElement) {
                                        // replace index of topArrangeElement with layout candidate
                                        $dyn.layout.topArrangeElements.elements[index] = layoutCandidate;
                                    }
                                    else if (invalidLayoutCandidate) {
                                        // do nothing here. leave the topArrangeElement in the queue
                                    }
                                    else {
                                        // both topArrangeElement and layoutCandidate are in the DOM
                                        // filter function will get a list of the common elements between the two lists, and the last one will be the lowest level in the tree.
                                        var intersection = currentArrangeElementParents.filter(candidateParents);
                                        if (intersection.length > 0) {
                                            $dyn.layout.topArrangeElements.elements[index] = intersection.last()[0];
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else {
                        // If we are not in a layout block, arrange the candidate immediately.
                        $dyn.layout.arrange(layoutCandidate);
                    }
                }
            }
        }
        layout.queueArrange = queueArrange;
        /**
         * Applies layout CSS attributes and columns to the immediate children of this container.
         * @param target The element to be arranged.
         * @param directArrange Indicates that the element was called from outside of the layout code. We need to do extra work to ensure that the element is still reflowed when necessary.
         * @param removeFocus Whether or not to call to $dyn.ui.removeFocus when there is an ArrangeMethod
         */
        function arrange(target, directArrange, removeFocus) {
            // Mark this as true when we enter the arrange so that any bindings that trigger updates on elements as part of the layout do not trigger additional layouts.
            $dyn.layout.inArrangeOrReflow = true;
            if ($dyn.layout.layoutContainer(target)) {
                target.dynHasArranged = true;
                var arrangeMethod = target.dynArrangeMethod;
                var columns = target.dynColumns;
                var alignment = target.dynAlignment;
                if (arrangeMethod !== undefined && arrangeMethod !== $dyn.layout.ArrangeMethod.none) {
                    if (removeFocus && !directArrange && !$dyn.layout._originalActiveElement) {
                        $dyn.layout._originalActiveElement = $dyn.ui.removeFocus($(target));
                        removeFocus = false;
                        if ($dyn.layout._originalActiveElement) {
                            $dyn.shell.bodyFocusCorrection = false;
                        }
                    }
                    if (columns === undefined) {
                        columns = 1;
                    }
                    if (columns != $dyn.layout.Columns.balanced && columns != $dyn.layout.Columns.fill) {
                        // If columns is not balanced or fill, remove any previous layout columns and breakable groups that might have been generated previously.
                        $dyn.layout.removeArrange(target);
                    }
                    var result = $dyn.layout.getChildrenAsFlexUnits(target);
                    var flexUnits = result.flexUnits;
                    var visibleFlexUnits = result.visibleFlexUnits;
                    var containerHasWidth = $dyn.layout.provider.isFillWidth(target) || $dyn.layout.provider.isFixedWidth(target);
                    var containerHasHeight = $dyn.layout.provider.isFillHeight(target) || $dyn.layout.provider.isFixedHeight(target);
                    if (arrangeMethod == $dyn.layout.ArrangeMethod.horizontalLeft) {
                        // Use basic flex-box layout to arrange items left to right.
                        $dyn.layout.provider.setHorizontalLeftContainer(target);
                        if (alignment === $dyn.layout.Alignment.bottom) {
                            $dyn.layout.provider.setHorizontalBottomAlign(target);
                        }
                        $dyn.layout.applyFlexSizes(target, flexUnits, containerHasWidth, containerHasHeight, "horizontal");
                    }
                    else if (arrangeMethod == $dyn.layout.ArrangeMethod.horizontalRight) {
                        // Use basic flex-box layout to arrange items left to right, flush right.
                        $dyn.layout.provider.setHorizontalRightContainer(target);
                        if (alignment === $dyn.layout.Alignment.bottom) {
                            $dyn.layout.provider.setHorizontalBottomAlign(target);
                        }
                        $dyn.layout.applyFlexSizes(target, flexUnits, containerHasWidth, containerHasHeight, "horizontal");
                    }
                    else if (columns == $dyn.layout.Columns.fill || columns == $dyn.layout.Columns.balanced) {
                        // Container uses dynamically generated columns.
                        // If the container already has balanced or fill columns generated, do not regenerate them.
                        var hasBalancedColumns = $(target).children(".balanced-column").length > 0;
                        var hasFillColumns = $(target).children(".fill-column").length > 0;
                        if (!hasBalancedColumns && !hasFillColumns) {
                            $dyn.layout.provider.setHorizontalLeftContainer(target); // Columns are aligned horizontally
                            // 'Fill' columns always start with 1 column and are expanded later.
                            var columnUnits = $dyn.layout.columnize(target, 1, visibleFlexUnits, arrangeMethod, columns);
                            if (columnUnits) {
                                $dyn.layout.applyFlexSizes(target, columnUnits, false, true, "horizontal");
                            }
                        }
                    }
                    else {
                        if (columns == $dyn.layout.Columns.limitHeight) {
                            // Use the default value for limit height. Consider adding an option to set this in the layout binding handler if a different
                            // default is ever needed for other controls.
                            var maxItems = $dyn.layout._defaultLimitHeight;
                            columns = Math.max(1, Math.ceil(visibleFlexUnits / maxItems));
                        }
                        // Single column containers do not need a generated column div, unless it is using a
                        // HorizontalWrap arrange method because in that case column size must be limited.
                        if (columns == 1 && arrangeMethod !== $dyn.layout.ArrangeMethod.horizontalWrap) {
                            $dyn.layout.provider.setVerticalContainer(target);
                            $dyn.layout.applyFlexSizes(target, flexUnits, containerHasWidth, containerHasHeight, "vertical");
                        }
                        else {
                            // More than one column is being used.
                            $dyn.layout.provider.setHorizontalLeftContainer(target); // Columns are aligned horizontally
                            // At this point ArrangeMethod is either HorizontalWrap or Vertical. HorizontalWrap always
                            // requires actual div objects for columns but Vertical only requires it if the number
                            // of columns is different than the number of visible children.
                            if (arrangeMethod === $dyn.layout.ArrangeMethod.horizontalWrap || columns != visibleFlexUnits) {
                                var columnUnits = $dyn.layout.columnize(target, columns, visibleFlexUnits, arrangeMethod, "");
                                $dyn.layout.applyFlexSizes(target, columnUnits, containerHasWidth, containerHasHeight, "horizontal");
                            }
                            else {
                                $dyn.layout.applyFlexSizes(target, flexUnits, containerHasWidth, containerHasHeight, "horizontal");
                                // if the number of columns is same as the number of visible children then there is only one row and we make sure everything is aligned to top
                                // Its needed to fix layout issues similar to bug #3443810
                                $dyn.layout.provider.setHorizontalTopAlign(target);
                            }
                        }
                    }
                    $dyn.layout.provider.apply(target);
                }
            }
            $(target)
                .children()
                .each(function (index, element) {
                if (element.getAttribute("data-dyn-lastvisible") != "false" && (!element.classList || !element.classList.contains("layout-ignoreArrange"))) {
                    $dyn.layout.arrange(element, false, removeFocus);
                }
            });
            // The arrange call was made from outside of the layout code, so we need to queue the target element for a reflow.
            // The element that may be queued is up to the nearest reflow-scope marker
            if (directArrange) {
                $dyn.layout.queueReflow(target);
            }
            $dyn.layout.inArrangeOrReflow = false;
        }
        layout.arrange = arrange;
        /**
         * Breaks up the children of the target allowed to be broken
         * @description If 'dynIsBreakable'=true, they can be broken.
         * The children to be broken are contained in the layout-container element of this target.
         * Each group keeps track of its original children so that those split out can be restored later.
         *
         * @private
         * @param target The container element.
         */
        function breakGroups(target) {
            /** Generates a new div for the new breakable group and copies the dependent properties to that element. */
            var createNewBreakableGroup = function (groupElement) {
                var newGroup = document.createElement("div");
                $(newGroup).addClass("layout-breakable-group");
                /// When generating new breakable groups, set the dynHasArranged flag to true so that when controls inside of them become visible at runtime,
                /// the group can be queued for an arrange. Otherwise, it will get skipped as a performance optimization which requires one full arrange of the base form elements before
                /// queueing any elements for an arrange.
                newGroup.dynHasArranged = true;
                // Call dataBind to allow unbind to recurse through these elements to their child controls.
                $dyn.dataBind(newGroup);
                return newGroup;
            };
            /**
             * Break groups
             * @description Groups will only be broken if VisibleChildrenCount > tailGroupCount+leadingGroupCount
             * Each child of the element with 'dynIsBreakable'=true will be split into its own group,
             * except for the leadingGroupCount of visible child, and all non-visible children before that, which remain in the original group.
             * @private
             * @param groupElement
             * @param leadingGroupCount Defines how many of the last visible children will go in a separate leading group.
             * @param tailGroupCount Defines how many of the last visible children will go in a separate tail group.
             * @returns Return array of {HtmlElement} breaked elements
             */
            var breakGroup = function (groupElement, leadingGroupCount, tailGroupCount) {
                // Layout container contains the children of the group that can be split into separate groups.
                var layoutContainer = $dyn.layout.layoutContainer(groupElement);
                // The current group is what we will be inserting after, so that children are kept in order.
                var siblingToInsertAfter = groupElement;
                // Will contain the list of groups that will be generated
                var breakableGroups = [];
                // Child flex units we will loop through to determine the correct spots for breaking.
                var childrenUnits = $dyn.layout.getChildrenAsFlexUnits(layoutContainer);
                // Only do the breaking if there are enough visible children
                if (childrenUnits.visibleFlexUnits > tailGroupCount + leadingGroupCount) {
                    var currentBreakableGroup = void 0;
                    var visibleChildren = 0;
                    var currentIndex = 0;
                    // Leave the last tailGroupCount visible children to put into the tail group.
                    while (visibleChildren < childrenUnits.visibleFlexUnits - tailGroupCount) {
                        var child = childrenUnits.flexUnits[currentIndex];
                        if (child.visible) {
                            if (visibleChildren > leadingGroupCount) {
                                // Skip the first leadingGroupCount child and leave them on leading group
                                layoutContainer.removeChild(child.element);
                                if (currentBreakableGroup) {
                                    // Add the group that was generated last to the list, before creating a new one below.
                                    breakableGroups.push(currentBreakableGroup);
                                }
                                // Generate a new breakable group and append the current element. Each child element will be moved into its own group,
                                // except for the last two, which is explained below.
                                currentBreakableGroup = createNewBreakableGroup(groupElement);
                                currentBreakableGroup.appendChild(child.element);
                                $(currentBreakableGroup).insertAfter(siblingToInsertAfter);
                                // The next group we generate should get inserted after this group so that we maintain the order of the child controls.
                                siblingToInsertAfter = currentBreakableGroup;
                            }
                            visibleChildren++;
                        }
                        // If the child is not visible, and a breakable group has been created, append non-visible children as well to maintain order.
                        if (!child.visible && currentBreakableGroup) {
                            currentBreakableGroup.appendChild(child.element);
                        }
                        currentIndex++;
                    }
                    // Append the last group to the list of breakable groups.
                    if (currentBreakableGroup) {
                        breakableGroups.push(currentBreakableGroup);
                    }
                    // The remaining children should go into the tail group.
                    // We will append at least "tailGroupCount" of visible children and the rest of the remaining non-visible children to this group.
                    var tailGroup = createNewBreakableGroup(groupElement);
                    $dyn.layout.provider.setVerticalContainer(tailGroup);
                    while (currentIndex < childrenUnits.flexUnits.length) {
                        var currentChild = childrenUnits.flexUnits[currentIndex];
                        tailGroup.appendChild(currentChild.element);
                        currentIndex++;
                    }
                    $(tailGroup).insertAfter(siblingToInsertAfter);
                    breakableGroups.push(tailGroup);
                }
                return breakableGroups;
            };
            // TODO unused - can be removed?
            var childrenChanged = false;
            /// Loop through the flexUnits and break any groups that are breakable.
            var flexUnitsResult = $dyn.layout.getChildrenAsFlexUnits(target);
            var flexUnits = flexUnitsResult.flexUnits;
            // tslint:disable-next-line:prefer-for-of
            for (var i = 0; i < flexUnits.length; i++) {
                var child = flexUnits[i];
                // If the group is breakable and has not already been broken once.
                if (child.element && child.element.dynIsBreakable && !child.element.dynBreakableGroups && child.visible) {
                    // number of children go to leading and tail groups can be overriden by a debug setting
                    // eg. ?debug={"leadinggroup":2,"tailgroup":3}  will set leading group count to 2 and tail group count to 3
                    var _leadingGroupCount = $dyn.debug.leadinggroup ? $dyn.debug.leadinggroup : 0;
                    // If group does not have caption then it is fully breakable (one last child goes to tail group).
                    // Otherwise we put the last two visible children into the tail group.
                    var _tailGroupCount = $dyn.debug.tailgroup ? $dyn.debug.tailgroup : $dyn.context(child.element).hasNoCaptionCSS ? 1 : 2;
                    // Try to break the group if it is visible. It will get broken if visible children > tailGroupCount, and the new groups will be returned.
                    var breakableGroups = breakGroup(child.element, _leadingGroupCount, _tailGroupCount);
                    if (breakableGroups.length > 0) {
                        // Add the tail-group class to the last element in the list
                        var lastGroup = breakableGroups[breakableGroups.length - 1];
                        $(lastGroup).addClass("layout-breakable-tail-group");
                        $(child.element).addClass("layout-breakable-group");
                        // Store the returned layout-breakable-group elements on the target for restoring later.
                        child.element.dynBreakableGroups = breakableGroups;
                        childrenChanged = true;
                        // Retrieve the context and update the properties on the generated groups.
                        var groupContext = $dyn.context(child.element);
                        if (groupContext) {
                            var options_1 = $dyn.layout.breakableGroupsOptions(groupContext);
                            $dyn.layout.copyBreakableGroupProperties(options_1, child.element);
                        }
                    }
                    else {
                        // If the group does not get broken, add the tail-group class.
                        $(child.element).addClass("layout-breakable-tail-group");
                    }
                }
            }
        }
        layout.breakGroups = breakGroups;
        /**
         * Obtains a list of corresponding flex units for each of the children.
         * @private
         * @param target The container element.
         * @returns List of FlexUnits
         */
        function getChildrenAsFlexUnits(target) {
            var childrenFlexUnit = [];
            var visibleCount = 0;
            var children = $(target).children();
            // tslint:disable-next-line:prefer-for-of
            for (var i = 0; i < children.length; i++) {
                var child = children[i];
                if (child.classList.contains("layout-ignore")) {
                    continue;
                }
                var unit = $dyn.layout.createFlexUnit(child);
                if (unit) {
                    if (unit.visible) {
                        visibleCount++;
                    }
                    childrenFlexUnit.push(unit);
                }
            }
            return { flexUnits: childrenFlexUnit, visibleFlexUnits: visibleCount };
        }
        layout.getChildrenAsFlexUnits = getChildrenAsFlexUnits;
        /**
         * Creates a FlexUnit for a given element which will hold its sizing related attributes.
         * @private
         * @param target The container element.
         */
        function createFlexUnit(target) {
            var unit = new $dyn.layout.FlexUnit();
            unit.element = target;
            unit.preferFlexWidth = target.dynPreferredWidth === $dyn.layout.Size.available;
            unit.preferFlexHeight = target.dynPreferredHeight === $dyn.layout.Size.available;
            unit.ignoreSiblingSizes = target.dynLayoutIgnoreSiblings;
            unit.children = [];
            unit.control = $dyn.context(target);
            var lastVisible = $(target).attr("data-dyn-lastvisible");
            if (target.style.display == "none") {
                unit.visible = false;
            }
            else if (unit.control) {
                unit.visible = $dyn.value(unit.control.Visible);
            }
            else if (lastVisible) {
                unit.visible = lastVisible == "true";
            }
            else {
                unit.visible = $(target).is(":visible");
            }
            return unit;
        }
        layout.createFlexUnit = createFlexUnit;
        /**
         * Removes any columns created for layout, leaving the children intact.
         *
         * @param target Container of the layout columns to remove.
         * @param fromContentHandler True if this is being called from the content handler; otherwise, false (called from arrange).
         */
        function removeArrange(target, fromContentHandler) {
            var $target = $(target);
            if ($target.hasClass("layout-column")) {
                // Exclude layout columns
                return;
            }
            var $layoutColumn = $target.children(".layout-column");
            $layoutColumn.detach();
            // Using prepend instead of append to insure that the children are placed
            // in the same dom location the layout column was in.
            $target.prepend($layoutColumn.children());
            if (fromContentHandler) {
                if (target.dynNeedsReflow === false) {
                    target.dynNeedsReflow = true;
                }
                // if from content handler we want to find the parent of the group control and restore groups
                // if from arrange we have already been to that control because we travel top down
                if (target.parentNode && target.parentNode.dynBreakableGroups && target.parentNode.dynBreakableGroups.length > 0) {
                    target = target.parentNode.parentNode;
                }
            }
            // Restore the groups that were broken
            if (target) {
                $dyn.layout.removeBreakableGroups(target);
                if (target.dynIsBroken == true) {
                    // We don't want to add this flag to all DOM element here, just on those that already have it
                    target.dynIsBroken = false; // Reset the container breakable groups flag, so reflow will know it needs to break this again.
                }
            }
        }
        layout.removeArrange = removeArrange;
        /**
         * Gets the breakable groups associated with the targetElement.
         * @internal
         * @param targetElement - The element for which to get the breakable groups.
         * @returns An array of brekable groups if they exist. Else an empty array.
         */
        function getBreakableGroups(targetElement) {
            var groups = targetElement && targetElement.dynBreakableGroups ? targetElement.dynBreakableGroups : [];
            return groups;
        }
        layout.getBreakableGroups = getBreakableGroups;
        /**
         * Gets the tail breakable group associated with the targetElement.
         * @internal
         * @param targetElement - The element for which to get the tail breakable group.
         * @returns The tail breakable group element; else null.
         */
        function getTailBreakableGroup(targetElement) {
            var groups = $dyn.layout.getBreakableGroups(targetElement);
            if (groups.length > 0) {
                return groups[groups.length - 1];
            }
            return null;
        }
        layout.getTailBreakableGroup = getTailBreakableGroup;
        /**
         * Restore the groups to their original state on the target element if they have any breakable groups.
         * @private
         * @param targetElement Container of the breakable groups.
         */
        function removeBreakableGroups(targetElement) {
            var children = $(targetElement).children();
            children.each(function (index, element) {
                if (element.dynIsBreakable) {
                    $(element).removeClass("layout-breakable-group");
                    if (element.dynBreakableGroups && element.dynBreakableGroups.length > 0) {
                        var layoutContainer_1 = $dyn.layout.layoutContainer(element);
                        $(layoutContainer_1).append($(element.dynBreakableGroups).children());
                        $(element.dynBreakableGroups).remove();
                        element.dynBreakableGroups = undefined;
                    }
                    // If the element is a breakable group generated div, and its children have been removed, remove it.
                    if (element.classList && element.classList.length == 1 && element.classList.contains("layout-breakable-group") && $(element).is(":empty")) {
                        $(element).remove();
                    }
                }
            });
        }
        layout.removeBreakableGroups = removeBreakableGroups;
        /**
         * Applies the 'fill-height' and 'fill-width' classes to the supplied children of this container.
         * @private
         * @param target Container of the supplied children.
         * @param children ContChildren to apply flex classes to.
         * @param containerHasWidth Does container have width independent of the contained controls.
         * @param containerHasHeight Does container have height independent of the contained controls.
         * @param flexAxis Axis of the flex direction of the children (vertical | horizontal).
         */
        function applyFlexSizes(target, children, containerHasWidth, containerHasHeight, flexAxis) {
            /**
             * Notifies an element that its size has been overridden by toggling the passed in observable
             *
             * @param overrideObservable The observable for the corresponding dimension
             * @param isOverriding The flag indicating if the observable for the corresponding dimension is to be overridden
             */
            var notifyOverride = function (overrideObservable, isOverriding) {
                if (overrideObservable && $dyn.isObservable(overrideObservable)) {
                    overrideObservable(isOverriding);
                }
            };
            var allFlexHeight = true;
            var allFlexWidth = true;
            // tslint:disable-next-line:prefer-for-of
            for (var i = 0; i < children.length; i++) {
                var flexUnit = children[i];
                if (!flexUnit.preferFlexHeight && flexUnit.visible) {
                    allFlexHeight = false;
                }
                if (!flexUnit.preferFlexWidth && flexUnit.visible) {
                    allFlexWidth = false;
                }
            }
            // tslint:disable-next-line:prefer-for-of
            for (var i = 0; i < children.length; i++) {
                var flexUnit = children[i];
                if (flexUnit.preferFlexWidth && (containerHasWidth || (!flexUnit.ignoreSiblingSizes && !allFlexWidth && flexAxis === "vertical"))) {
                    // Width can only flex if the parent container has width already or there is a sibling that can provide width.
                    $dyn.layout.provider.setFillWidth(flexUnit.element);
                    // Notify the override observable that the width is not overridden so that it can update if needed.
                    notifyOverride(flexUnit.element.dynWidthOverride, false);
                }
                else {
                    $dyn.layout.provider.removeFillWidth(flexUnit.element);
                    if (flexUnit.preferFlexWidth) {
                        // Notify the override observable that the width is overridden so it can update internal sizing.
                        notifyOverride(flexUnit.element.dynWidthOverride, true);
                    }
                    // Assign increasing-width container class. Width can only increase when not fixed or fill-width
                    if (!$dyn.layout.provider.isFixedWidth(flexUnit.element) && flexUnit.element.dynIncreasingWidth) {
                        $dyn.layout.provider.setFixedIncreasingWidth(flexUnit.element);
                    }
                }
                if (flexUnit.preferFlexHeight && (containerHasHeight || (!flexUnit.ignoreSiblingSizes && !allFlexHeight && flexAxis == "horizontal"))) {
                    // Height can only flex if the parent container has height already or there is a sibling that can provide height.
                    $dyn.layout.provider.setFillHeight(flexUnit.element);
                    // Notify the override observable that the height is not overridden so that it can update if needed.
                    notifyOverride(flexUnit.element.dynHeightOverride, false);
                }
                else {
                    $dyn.layout.provider.removeFillHeight(flexUnit.element);
                    if (flexUnit.preferFlexHeight) {
                        // Notify the override observable that the height is overridden so it can update internal sizing.
                        notifyOverride(flexUnit.element.dynHeightOverride, true);
                    }
                    // Assign increasing-height container class. Height can only increase when not fixed or fill-height
                    if (!$dyn.layout.provider.isFixedHeight(flexUnit.element) && flexUnit.element.dynIncreasingHeight) {
                        $dyn.layout.provider.setFixedIncreasingHeight(flexUnit.element);
                    }
                }
            }
        }
        layout.applyFlexSizes = applyFlexSizes;
        /**
         * Columnize the children of this container.
         * @private
         * @param target Container of the supplied children.
         * @param fixedColumns Number of columns to create.
         * @param visibleItems Number of children that are currently visible.
         * @param arrangeMethod Does container have height independent of the contained controls.
         * @param columns Axis of the flex direction of the children (vertical | horizontal).
         * @returns FlexUnit list
         */
        function columnize(target, fixedColumns, visibleItems, arrangeMethod, columns) {
            var columnUnits = [];
            var $target = $(target);
            var children = $target.children();
            // Create the column objects up front.
            fixedColumns = Math.min(fixedColumns, visibleItems);
            // Always create at least one fixed column
            if (fixedColumns < 1) {
                fixedColumns = 1;
            }
            for (var i = 0; i < fixedColumns; i++) {
                var columnUnit = $dyn.layout.createColumn(arrangeMethod == $dyn.layout.ArrangeMethod.horizontalWrap, columns == $dyn.layout.Columns.fill, columns == $dyn.layout.Columns.balanced, false);
                columnUnits.push(columnUnit);
                $target.append(columnUnit.element);
            }
            if (children.length > 0) {
                // Find the average number of elements per column and distribute the controls appropriately.
                // The remainder is evenly distributed amongst columns, starting with the first.
                var averageElementsPerColumn = visibleItems / fixedColumns;
                var remainder = visibleItems % fixedColumns;
                var currentCount = 0;
                var currentColumn = 0;
                // tslint:disable-next-line:prefer-for-of
                for (var i = 0; i < children.length; i++) {
                    var childElement = children[i];
                    if (childElement.classList.contains("layout-ignore")) {
                        continue;
                    }
                    var flexUnit = $dyn.layout.createFlexUnit(childElement);
                    if (flexUnit) {
                        // If the current element is invisible then don't increment the column count, just allow the item to
                        // silently be added so that it retains its position relative to siblings.
                        if (flexUnit.visible) {
                            currentCount++;
                            // Change to the next column once this column has all it needs.
                            var remainderAdd = currentColumn < remainder ? 1 : 0;
                            if (currentCount > averageElementsPerColumn + remainderAdd && columnUnits[currentColumn + 1]) {
                                currentColumn++;
                                currentCount = 1;
                            }
                            columnUnits[currentColumn].preferFlexWidth = columnUnits[currentColumn].preferFlexWidth || flexUnit.preferFlexWidth;
                            columnUnits[currentColumn].preferFlexHeight = columnUnits[currentColumn].preferFlexHeight || flexUnit.preferFlexHeight;
                        }
                        columnUnits[currentColumn].children.push(flexUnit);
                        columnUnits[currentColumn].element.appendChild(flexUnit.element);
                    }
                }
            }
            return columnUnits;
        }
        layout.columnize = columnize;
        /**
         * Creates a new columns.
         * @private
         * @param wrapColumn Indicates if horizontal wrap columns should be used.
         * @param fillColumn Indicate if fill columns should be used.
         * @param balancedColumn Indicate if balanced columns should be used.
         * @param reflow Indicates if we are coming from reflow.
         * In that case, we should add the layout classes directly because we do not make a call to $dyn.layout.arrange on the columns generated during reflow.
         * @returns Column object.
         */
        function createColumn(wrapColumn, fillColumn, balancedColumn, reflow) {
            var flexUnit = new $dyn.layout.FlexUnit();
            var element = document.createElement("div");
            element.classList.add("layout-column");
            flexUnit.element = element;
            flexUnit.visible = true;
            flexUnit.children = [];
            element.dynHasArranged = true;
            // Call dataBind to allow unbind to recurse through these elements to their child controls.
            $dyn.dataBind(element);
            var isDynamicOrWrapColumn = fillColumn || balancedColumn || wrapColumn;
            var isDynamicColumn = fillColumn || balancedColumn;
            if (wrapColumn) {
                element.classList.add("wrap-column");
            }
            if (balancedColumn) {
                element.classList.add("balanced-column");
            }
            else if (fillColumn) {
                element.classList.add("fill-column");
            }
            if (reflow) {
                // Add classes directly because arrange will not be called on this column
                if (!isDynamicOrWrapColumn) {
                    // For fixed columns only, add the layout-container and layout-vertical classes. These will be the only columns
                    // that will support having fill-height/fill-width children.
                    $dyn.layout.provider.setVerticalContainer(element);
                }
                if (isDynamicColumn) {
                    element.classList.add("fill-height");
                }
            }
            else {
                // Use the binding handler and variable because arrange will be called on this column.
                if (!isDynamicOrWrapColumn) {
                    // For fixed columns only, add the layout-container and layout-vertical classes. These will be the only columns
                    // that will support having fill-height/fill-width children.
                    $dyn.bindingHandlers.layout.invoke(element, { arrangeMethod: $dyn.layout.ArrangeMethod.vertical });
                }
                if (isDynamicColumn) {
                    flexUnit.preferFlexHeight = true;
                }
            }
            return flexUnit;
        }
        layout.createColumn = createColumn;
        /** Helper structure used to represent a flexible item in the dom tree. */
        var FlexUnit = /** @class */ (function () {
            function FlexUnit() {
            }
            return FlexUnit;
        }());
        layout.FlexUnit = FlexUnit;
        layout._reflowTask = $dyn.debug.performance ? new $dyn.DomPerformanceTask("reflow") : null;
        /**
         * Reflows the children of the container.
         * It is suggested to use $dyn.layout.queueArrange instead of directly calling reflow.
         * @internal
         * @param reflowElements The collection of elements to reflow.
         * @param resize True if is called from a window.resize event; otherwise, false.
         */
        function reflow(reflowElements, resize) {
            $dyn.layout._notifyReflowHandlers(reflowElements, $dyn.layout.startReflowHandlers);
            var perfElement = $(reflowElements)[0];
            $dyn.layout._reflowTask && $dyn.layout._reflowTask.start(perfElement);
            // Mark this as true when we enter the reflow so that any bindings that trigger updates on elements as part of the reflow do not trigger additional layouts.
            $dyn.layout.inArrangeOrReflow = true;
            var fillColumnContainers = $(".fill-column", reflowElements)
                .parent()
                .filter(":visible");
            var balancedColumnContainers = $(".balanced-column", reflowElements)
                .parent()
                .filter(":visible");
            var originalActiveElement;
            var restoreFocus = (fillColumnContainers.length && (originalActiveElement = $dyn.ui.removeFocus(fillColumnContainers))) ||
                (balancedColumnContainers.length && (originalActiveElement = $dyn.ui.removeFocus(balancedColumnContainers))); // Remove focus from activeElement if it is being rearranged.
            var oldValue = $dyn.shell.bodyFocusCorrection;
            if (originalActiveElement) {
                $dyn.shell.bodyFocusCorrection = false;
            }
            $dyn.layout.breakAndReflow(fillColumnContainers, ".fill-column", $dyn.layout.precomputeReflowSizes.fill, $dyn.layout.fillColumn.reflow);
            $dyn.layout.breakAndReflow(balancedColumnContainers, ".balanced-column", $dyn.layout.precomputeReflowSizes.balanced, $dyn.layout.balancedColumn.reflow);
            if (restoreFocus) {
                $dyn.ui.restoreFocus(originalActiveElement);
                $dyn.shell.bodyFocusCorrection = oldValue;
            }
            // Adjust height/width for increasing height containers marked with 'layout-increasing-height/layout-increasing-width' classes.
            $dyn.layout.resizeDynamicContainers(reflowElements, resize);
            $dyn.layout._notifyReflowHandlers(reflowElements, $dyn.layout.endReflowHandlers);
            $dyn.layout.inArrangeOrReflow = false;
            $dyn.layout._reflowTask && $dyn.layout._reflowTask.stop(perfElement);
        }
        layout.reflow = reflow;
        /**
         * Break and reflows the children of the container.
         * @private
         * @param columnContainers The collection of elements to reflow.
         * @param columnsClass CSS class corresponding to the column type.
         * @param precomputations A precomputations function  for the column type.
         * @param reflow A reflow function for the column type.
         */
        function breakAndReflow(columnContainers, columnsClass, precomputations, reflow) {
            /**
             * Collapse the columns of a container into one.
             * @param fillOrBalanced Indicates whether the container has fill or balanced columns.
             * @param container The column container.
             */
            var collapseColumns = function (fillOrBalanced, container) {
                var columns = $(container).children(fillOrBalanced);
                // Collapse to single column
                var firstColumn = columns.first();
                firstColumn.append(columns.children());
                $(fillOrBalanced + ":empty", container).remove();
                columns = $(container).children(fillOrBalanced);
                if (!columns.length) {
                    // If all of the columns have been removed, return false which indicates that the container should not be reflowed.
                    return false;
                }
                return true;
            };
            // tslint:disable-next-line:prefer-for-of
            for (var i = 0; i < columnContainers.length; i++) {
                var columnContainer = columnContainers[i];
                // Trigger breakable groups. If the breaking has already been done, this will be skipped.
                var firstColumn = $(columnContainer)
                    .children()
                    .first()[0];
                var previousIsBroken = columnContainer.dynIsBroken;
                if (!previousIsBroken) {
                    $dyn.layout.breakGroups(firstColumn);
                    columnContainer.dynIsBroken = true; // Flag to indicate that this columnContainer has had breakGroups called on it once.
                }
                // Measure sizes and visibility first for performance.
                precomputations(columnContainer);
                if (columnContainer.dynNeedsReflow) {
                    // Collapse the columns into one. If any column container has no columns after this step, reflow will be skipped.
                    var reflowNeeded = collapseColumns(columnsClass, columnContainer);
                    // Check if we need to re-break the group if it was already broken before the reflow. This can happen when visibility of one of the child elements has changed.
                    if (previousIsBroken && columnContainer.dynNeedsBroken) {
                        $dyn.layout.removeBreakableGroups(firstColumn);
                        $dyn.layout.breakGroups(firstColumn);
                        precomputations(columnContainer);
                    }
                    if (reflowNeeded) {
                        reflow(columnContainer);
                    }
                }
            }
        }
        layout.breakAndReflow = breakAndReflow;
        /**
         * Pre-compute sizes of the containers to improve preformance.
         * @private
         */
        var precomputeReflowSizes;
        (function (precomputeReflowSizes) {
            /**
             * Measure and store the height/width/visibility of each child in the container so we can retrieve them once at the beginning for performance.
             * @private
             * @param columnContainer The column container whose children we want to distribute.
             */
            function measureChildren(columnContainer) {
                var visibleChildren = 0;
                // Measure the children sizes and visibility
                var columns = $(columnContainer).children();
                // tslint:disable-next-line:prefer-for-of
                for (var j = 0; j < columns.length; j++) {
                    // Use this class to remove the group margins because we do not want to include them in the height calculations
                    // since they are only applied conditionally to the non first item in a column.
                    var column = columns[j];
                    $(column).addClass("layout-reflow-measure");
                    var children_1 = $(column).children();
                    // tslint:disable-next-line:prefer-for-of
                    for (var k = 0; k < children_1.length; k++) {
                        var element = children_1[k];
                        var control = $dyn.context(element);
                        var elementObject = $(element);
                        if ((control && $dyn.value(control.Visible)) || ((!control || control.Visible === undefined) && elementObject.is(":visible"))) {
                            var newWidth = elementObject.outerWidth(true);
                            var newHeight = elementObject.outerHeight(true);
                            if (newWidth != element.dynReflowWidth || newHeight != element.dynReflowHeight) {
                                // If height or width of the child has changed, or they were not yet defined, the container will need to be reflowed.
                                columnContainer.dynNeedsReflow = true;
                                columnContainer.dynNeedsBroken = true;
                                element.dynReflowHeight = newHeight;
                                element.dynReflowWidth = newWidth;
                            }
                            if (element.dynReflowVisible != true) {
                                // The container needs to be re-broken and reflowed.
                                columnContainer.dynNeedsBroken = true;
                                columnContainer.dynNeedsReflow = true;
                                element.dynReflowVisible = true;
                            }
                            visibleChildren++;
                        }
                        else {
                            if (element.dynReflowVisible != false) {
                                // Visibility of the control changed, or was not yet defined, which will require a reflow of the container.
                                columnContainer.dynNeedsReflow = true;
                                columnContainer.dynNeedsBroken = true;
                                element.dynReflowVisible = false;
                            }
                            element.dynReflowWidth = 0;
                            element.dynReflowHeight = 0;
                        }
                    }
                    $(column).removeClass("layout-reflow-measure");
                }
                columnContainer.dynVisibleChildren = visibleChildren;
                // Here we hide the children of the first column so we can get the min column size.
                // Store the padding, minColumnWidth, and visibleChildren on the column container by measuring it from the first column.
                if (columnContainer.dynMinColumnWidth == undefined) {
                    columnContainer.dynMinColumnWidth = {};
                }
                // if density has been changed we need to recalculate the column width
                var currentDensity = $dyn.densityThemeManager._getCurrentDensity();
                if (columnContainer.dynMinColumnWidth.value == undefined || columnContainer.dynMinColumnWidth.density != currentDensity) {
                    var firstColumn = columns.first();
                    // Store the minimum column width and padding on the column container, plus the number of visible children.
                    firstColumn.addClass("layout-hide-children");
                    columnContainer.dynMinColumnWidth.value = firstColumn.outerWidth(true);
                    columnContainer.dynMinColumnWidth.density = currentDensity;
                    columnContainer.dynColumnPadding = columnContainer.dynMinColumnWidth.value - firstColumn.width();
                    firstColumn.removeClass("layout-hide-children");
                }
            }
            precomputeReflowSizes.measureChildren = measureChildren;
            /**
             * Apply fill method
             * @private
             * @param columnContainer The column container
             */
            function fill(columnContainer) {
                columnContainer.dynNeedsBroken = false;
                // Detect the height of the container. If it has changed from previous height, reflow is needed.
                // Subtract some tolerance for the appearance of scrollbars after the calculations.
                var containerHeight = columnContainer.clientHeight - 15;
                if (containerHeight != columnContainer.dynContainerHeight) {
                    columnContainer.dynNeedsReflow = true;
                    columnContainer.dynContainerHeight = containerHeight;
                }
                $dyn.layout.precomputeReflowSizes.measureChildren(columnContainer);
            }
            precomputeReflowSizes.fill = fill;
            /**
             * Apply balanced method
             * @private
             * @param columnContainer The column container
             */
            function balanced(columnContainer) {
                columnContainer.dynNeedsBroken = false;
                // Detect the width of the container. If it has changed from previous width, reflow is needed.
                // Subtract some tolerance for the appearance of scrollbars after the calculations.
                var containerWidth = columnContainer.clientWidth - 15;
                if (containerWidth != columnContainer.dynContainerWidth) {
                    columnContainer.dynNeedsReflow = true;
                    columnContainer.dynContainerWidth = containerWidth;
                }
                $dyn.layout.precomputeReflowSizes.measureChildren(columnContainer);
            }
            precomputeReflowSizes.balanced = balanced;
        })(precomputeReflowSizes = layout.precomputeReflowSizes || (layout.precomputeReflowSizes = {}));
        /**
         * Reflows the children of a fill-column into columns to fill the available height in the parent container.
         * @description Can cause issues with the focus of the ActiveElement if it is contained by the element being layed out. This is because the element may be reappended in a new place.
         * @private
         */
        var fillColumn;
        (function (fillColumn) {
            /**
             * @param containerElement The parent container whose children we want to distribute.
             */
            function reflow(containerElement) {
                var container = $(containerElement);
                var columns = container.children(".fill-column");
                var firstColumn = columns.first();
                var allowMultipleItemsPerRow = firstColumn.hasClass("wrap-column");
                if (firstColumn && firstColumn.length > 0) {
                    var currentWidth = 0;
                    // Subtract some tolerance for the appearance of scrollbars after the calculations.
                    var availableHeight = containerElement.dynContainerHeight;
                    var availableWidth = containerElement.dynMinColumnWidth.value;
                    if (availableHeight <= 0) {
                        // If the container has no height available, do nothing.
                        // Subsequent reflow calls after this container has fully rendered should handle any reflow needed.
                        return;
                    }
                    var newColumnCounts = [];
                    var children_2 = firstColumn.children();
                    var remaining = children_2.length;
                    // Flow new columns as necessary
                    // This algorithm is largely just a prediction of what inline-block will do within a column so we can decided how many columns to make
                    // and which items go in each.
                    while (remaining > 0) {
                        var currentHeight = 0; // Excluding currentRowHeight (below).
                        var keepCount = 0; // For this column, it is the number of items being kept.
                        var currentWidth_1 = 0; // Width of the column, so far.
                        var rowItemCount = 0; // Number of items in the current 'row' inside the column. (items can appear side-by-side if there is enough column width)
                        var currentRowHeight = 0; // Current height of the row, so far.
                        // This loop creates and fills a new column.
                        while (currentHeight < availableHeight && remaining > 0) {
                            var nextChild = children_2[children_2.length - remaining];
                            var newRow = false;
                            // keepCount > 0 : There must be at least one item kept for the column, regardless, so don't allow it to exit here.
                            // Otherwise, exit if the nextChild will cause the the column to overflow if added to the current row.
                            if (keepCount > 0 && currentHeight + Math.max(currentRowHeight, nextChild.dynReflowHeight) > availableHeight) {
                                break;
                            }
                            else if (!allowMultipleItemsPerRow || (rowItemCount > 0 && currentWidth_1 + nextChild.dynReflowWidth > availableWidth)) {
                                // Above check determines if a new row is necessary. Indicates true if a) only one item is ever allowed per row, or
                                // b) adding the item to the row will cause it to overflow UNLESS it is the only item in the row.
                                newRow = true;
                            }
                            if (newRow) {
                                currentHeight += currentRowHeight;
                                currentRowHeight = nextChild.dynReflowHeight;
                                currentWidth_1 = nextChild.dynReflowWidth;
                                availableWidth = Math.max(currentWidth_1, availableWidth);
                                rowItemCount = 0;
                                // If after attempting to create the new row it will cause the height to overflow then exit without taking the item for this column.
                                if (keepCount > 0 && currentHeight + nextChild.dynReflowHeight > availableHeight) {
                                    break;
                                }
                            }
                            else {
                                currentRowHeight = Math.max(currentRowHeight, nextChild.dynReflowHeight);
                                currentWidth_1 += nextChild.dynReflowWidth;
                                availableWidth = Math.max(currentWidth_1, availableWidth);
                            }
                            rowItemCount++;
                            keepCount++;
                            remaining--;
                        }
                        newColumnCounts.push(keepCount);
                    }
                    for (var i = 1; i < newColumnCounts.length; i++) {
                        var newColumn = $($dyn.layout.createColumn(firstColumn.hasClass("wrap-column"), true, false, true).element);
                        container.append(newColumn);
                        for (var j = 0; j < newColumnCounts[i]; j++) {
                            newColumn.append(firstColumn.children()[newColumnCounts[0]]);
                        }
                    }
                    $dyn.layout.provider.apply(containerElement);
                }
                containerElement.dynNeedsReflow = false;
            }
            fillColumn.reflow = reflow;
        })(fillColumn = layout.fillColumn || (layout.fillColumn = {}));
        /**
         * Reflows the children of a balanced-column container into columns to fill the available width in the parent container.
         * @description Can cause issues with the focus of the ActiveElement if it is contained by the element being layed out. This is because the element may be reappended in a new place.
         * @private
         */
        var balancedColumn;
        (function (balancedColumn) {
            /**
             * @param containerElement The parent container whose children we want to distribute.
             */
            function reflow(containerElement) {
                var container = $(containerElement);
                var firstColumn = container.children().first();
                var currentColumn = firstColumn[0];
                var visibleChildren = containerElement.dynVisibleChildren;
                var columnPadding = containerElement.dynColumnPadding;
                var minColumnWidth = containerElement.dynMinColumnWidth.value;
                var containerWidth = containerElement.dynContainerWidth;
                // Keep a count of how many items will be moved into each column.
                // Move the children after figuring out how many will end up in each column at the end.
                // Initially adding all children so that we make sure we are not missing invisible children
                var newColumnCounts = [];
                newColumnCounts.push(firstColumn.children().length);
                // Compute the initial average height across columns
                var totalHeight = $dyn.layout.sizeCache.getCachedColumnHeight(0, newColumnCounts, 0, currentColumn);
                var totalColumns = 1;
                var averageHeight = totalHeight / totalColumns;
                // Generate new columns based on the width of the current column. To add another column, we should be able to add one of the width of the current column.
                var lastColumnWidth = Math.max($dyn.layout.sizeCache.getCachedColumnWidth(0, newColumnCounts, 0, currentColumn) + columnPadding, minColumnWidth);
                var totalSpaceUsed = lastColumnWidth;
                var lastColumnWithWidth = lastColumnWidth;
                while (totalColumns < visibleChildren && totalSpaceUsed <= containerWidth - lastColumnWidth) {
                    // Increment the column count of total number of columns in this container.
                    totalColumns++;
                    newColumnCounts.push(0); // Start the next column count at 0. We will increment it as we decide to move items into that column below.
                    // Recompute the average height of the columns
                    averageHeight = totalHeight / totalColumns;
                    // Loop through the columns again and redistribute the items
                    var currentColumnIndex = 0;
                    currentColumn = firstColumn[0];
                    var preceding = 0; // Sum of all column counts so far (# children total across preceding columns)
                    while (currentColumnIndex < totalColumns - 1) {
                        var currentHeight = $dyn.layout.sizeCache.getCachedColumnHeight(currentColumnIndex, newColumnCounts, preceding, currentColumn);
                        var moveItem = $(currentColumn).children()[preceding + newColumnCounts[currentColumnIndex] - 1];
                        if ($dyn.layout.sizeCache.visibleChildrenCount(currentColumnIndex, newColumnCounts, preceding, currentColumn) > 1 &&
                            currentHeight - moveItem.dynReflowHeight / 2 > averageHeight) {
                            // Decrement the count in the current column index, and increment the count in the next column index
                            newColumnCounts[currentColumnIndex]--;
                            newColumnCounts[currentColumnIndex + 1]++;
                        }
                        else {
                            preceding = preceding + newColumnCounts[currentColumnIndex]; // Update the total of items left in the previous columns.
                            currentColumnIndex++;
                        }
                    }
                    // Find the width of the last column and add that to the total space we have used.
                    lastColumnWidth = Math.max($dyn.layout.sizeCache.getCachedColumnWidth(currentColumnIndex, newColumnCounts, preceding, currentColumn) + columnPadding, minColumnWidth);
                    // If the last column was empty, assume it will potentially have a width of the previous column that had width. We cannot assume it will
                    // remain empty in the next round
                    lastColumnWidth == 0 ? (lastColumnWidth = lastColumnWithWidth) : (lastColumnWithWidth = lastColumnWidth);
                    totalSpaceUsed = totalSpaceUsed + lastColumnWidth;
                }
                // Move the children into the columns based on what was calculated above.
                for (var i = 1; i < newColumnCounts.length; i++) {
                    var newColumn = $($dyn.layout.createColumn(firstColumn.hasClass("wrap-column"), false, true, true).element);
                    container.append(newColumn);
                    for (var j = 0; j < newColumnCounts[i]; j++) {
                        newColumn.append(firstColumn.children()[newColumnCounts[0]]);
                    }
                }
                $dyn.layout.provider.apply(containerElement);
                containerElement.dynNeedsReflow = false;
            }
            balancedColumn.reflow = reflow;
        })(balancedColumn = layout.balancedColumn || (layout.balancedColumn = {}));
        /**
         * Internal helper class to provide size caching functions
         * @private
         */
        var sizeCache;
        (function (sizeCache) {
            /**
             * Gets the cached column height.
             * @private
             * @param columnIndex The index in the columnCounts array corresponding to the desired column.
             * @param columnCounts An array containing the counts of the number of children to be placed in each column.
             * @param preceding The number of visible children so far that are currently placed in preceding columns.
             * @param columnObject The column containing the children to measure.
             * @returns Cached height.
             */
            function getCachedColumnHeight(columnIndex, columnCounts, preceding, columnObject) {
                var height = 0;
                var children = $(columnObject).children();
                var childrenInColumn = columnCounts[columnIndex]; // Number of children that are currently placed at that column index
                for (var i = preceding; i < preceding + childrenInColumn; i++) {
                    height += children[i].dynReflowHeight;
                }
                return height;
            }
            sizeCache.getCachedColumnHeight = getCachedColumnHeight;
            /**
             * Gets the cached column width
             * @private
             * @param columnIndex The index in the columnCounts array corresponding to the desired column.
             * @param columnCounts An array containing the counts of the number of children to be placed in each column.
             * @param preceding The number of visible children so far that are currently placed in preceding columns.
             * @param columnObject The column containing the children to measure.
             * @returns Cached width.
             */
            function getCachedColumnWidth(columnIndex, columnCounts, preceding, columnObject) {
                var width = 0;
                var children = $(columnObject).children();
                var childrenInColumn = columnCounts[columnIndex]; // Number of children that are currently placed at that column index
                for (var i = preceding; i < preceding + childrenInColumn; i++) {
                    width = Math.max(children[i].dynReflowWidth, width);
                }
                return width;
            }
            sizeCache.getCachedColumnWidth = getCachedColumnWidth;
            /**
             * Gets the number of visible children in a current column
             * @private
             * @param columnIndex The index in the columnCounts array corresponding to the desired column.
             * @param columnCounts An array containing the counts of the number of children to be placed in each column.
             * @param preceding The number of visible children so far that are currently placed in preceding columns.
             * @param columnObject The column containing the children to measure.
             * @returns Cached number of visible children in a given column index.
             */
            function visibleChildrenCount(columnIndex, columnCounts, preceding, columnObject) {
                var count = 0;
                var children = $(columnObject).children();
                var childrenInColumn = columnCounts[columnIndex]; // Number of children that are currently placed at that column index
                for (var i = preceding; i < preceding + childrenInColumn; i++) {
                    if (children[i].dynReflowVisible) {
                        count++;
                    }
                }
                return count;
            }
            sizeCache.visibleChildrenCount = visibleChildrenCount;
        })(sizeCache = layout.sizeCache || (layout.sizeCache = {}));
        /**
         * For a container that has fixed-increasing-height, or fixed-increasing-width, retrieve the current height of the element and set the fixed height to the current height if it is larger.
         * @private
         * @param target DOM element
         * @param resize True if the call was triggered by a browser resize.
         */
        function resizeDynamicContainers(target, resize) {
            var increasingHeightContainers = $(target)
                .parent()
                .find(".fixed-increasing-height");
            increasingHeightContainers.each(function (index1, containerElement) {
                // reset the min-height if we have come from a browser resize.
                if (resize) {
                    containerElement.style.minHeight = "";
                }
                var containerElementObject = $(containerElement);
                // Find the current height and set the height of the container to that height if it is greater than the stored height
                var outerHeight = containerElementObject.height();
                var curHeight = containerElementObject.data("dynMinFlexHeight");
                // tslint:disable-next-line:radix
                if (resize || curHeight == undefined || outerHeight > parseInt(curHeight)) {
                    var heightPx = outerHeight + "px";
                    containerElement.style.minHeight = heightPx;
                    containerElementObject.data("dynMinFlexHeight", heightPx);
                    $dyn.layout.provider.apply(containerElement.parentNode);
                }
            });
            var increasingWidthContainers = $(target)
                .parent()
                .find(".fixed-increasing-width");
            increasingWidthContainers.each(function (index1, containerElement) {
                // Reset the min-width if we have come from a browser resize.
                if (resize) {
                    containerElement.style.minWidth = "";
                }
                var containerElementObject = $(containerElement);
                // Find the current width and set the width of the container to that width if it is greater than the stored width
                var outerWidth = containerElementObject.width();
                var curWidth = containerElementObject.data("dynMinFlexWidth");
                // tslint:disable-next-line:radix
                if (resize || curWidth == undefined || outerWidth > parseInt(curWidth)) {
                    var widthPx = outerWidth + "px";
                    containerElement.style.minWidth = widthPx;
                    containerElementObject.data("dynMinFlexWidth", widthPx);
                    $dyn.layout.provider.apply(containerElement.parentNode);
                }
            });
        }
        layout.resizeDynamicContainers = resizeDynamicContainers;
        var BaseLayoutProvider = /** @class */ (function () {
            function BaseLayoutProvider(_providerName) {
                if (_providerName === void 0) { _providerName = null; }
                this.name = _providerName;
            }
            /**
             * Sets an element to be a container of children that will laid out horizontally.
             */
            BaseLayoutProvider.prototype.setHorizontalLeftContainer = function (target) {
                target.classList.add("layout-container");
                target.classList.add("layout-horizontal");
                target.classList.remove("layout-vertical");
                target.classList.remove("layout-right");
            };
            /**
             * Sets an element to be a container of children that will laid out horizontally.
             */
            BaseLayoutProvider.prototype.setHorizontalRightContainer = function (target) {
                target.classList.add("layout-container");
                target.classList.add("layout-horizontal");
                target.classList.add("layout-right");
                target.classList.remove("layout-vertical");
            };
            /**
             * Sets an element to be bottom-aligned
             */
            BaseLayoutProvider.prototype.setHorizontalBottomAlign = function (target) {
                target.classList.add("layout-horizontal-bottomalign");
            };
            /**
             * Sets an element to be top-aligned
             */
            BaseLayoutProvider.prototype.setHorizontalTopAlign = function (target) {
                target.classList.add("layout-horizontal-topalign");
            };
            /**
             * Indicates if the provided element is a horizontal layout container.
             */
            BaseLayoutProvider.prototype.isHorizontal = function (target) {
                return target.classList.contains("layout-horizontal");
            };
            /**
             * Sets an element to be a container of children that will will layed out vertically.
             */
            BaseLayoutProvider.prototype.setVerticalContainer = function (target) {
                target.classList.add("layout-container");
                target.classList.add("layout-vertical");
                target.classList.remove("layout-horizontal");
                target.classList.remove("layout-right");
            };
            /**
             * Indicates if the provided element is a vertical layout container.
             */
            BaseLayoutProvider.prototype.isVertical = function (target) {
                return target.classList.contains("layout-vertical");
            };
            /**
             * Removes the layout container state of an element.
             */
            BaseLayoutProvider.prototype.removeLayoutContainer = function (target) {
                target.classList.remove("layout-container");
            };
            /**
             * Indicates if an element is set to use a fill-width.
             */
            BaseLayoutProvider.prototype.isFillWidth = function (target) {
                return target.classList.contains("fill-width");
            };
            /**
             * Sets the fill-width mode for a child element.
             */
            BaseLayoutProvider.prototype.setFillWidth = function (target) {
                target.classList.add("fill-width");
            };
            /**
             * Removes the fill-width mode for a child element.
             */
            BaseLayoutProvider.prototype.removeFillWidth = function (target) {
                target.classList.remove("fill-width");
            };
            /**
             * Indicates if an element is set to have a fixed width.
             */
            BaseLayoutProvider.prototype.isFixedWidth = function (target) {
                return target.classList.contains("fixed-width");
            };
            /**
             * Sets an element to indicate it has a fixed width.
             */
            BaseLayoutProvider.prototype.setFixedWidth = function (target) {
                target.classList.add("fixed-width");
            };
            /**
             * Removes the fixed width status of an element.
             */
            BaseLayoutProvider.prototype.removeFixedWidth = function (target) {
                target.classList.remove("fixed-width");
            };
            /**
             * Indicates if an element is set to have a fixed increasing width.
             */
            BaseLayoutProvider.prototype.isFixedIncreasingWidth = function (target) {
                return target.classList.contains("fixed-increasing-width");
            };
            /**
             * Removes the fixed width status of an element.
             */
            BaseLayoutProvider.prototype.setFixedIncreasingWidth = function (target) {
                target.classList.add("fixed-increasing-width");
            };
            /**
             * Removes the fixed-increasing-width status of an element.
             */
            BaseLayoutProvider.prototype.removeFixedIncreasingWidth = function (target) {
                target.classList.remove("fixed-increasing-width");
            };
            /**
             * Indicates if an element is set to use a fill-height.
             */
            BaseLayoutProvider.prototype.isFillHeight = function (target) {
                return target.classList.contains("fill-height");
            };
            /**
             * Sets the fill-height mode for a child element.
             */
            BaseLayoutProvider.prototype.setFillHeight = function (target) {
                target.classList.add("fill-height");
            };
            /**
             * Removes the fill-height mode for a child element.
             */
            BaseLayoutProvider.prototype.removeFillHeight = function (target) {
                target.classList.remove("fill-height");
            };
            /**
             * Indicates if an element is set to use a fixed height.
             */
            BaseLayoutProvider.prototype.isFixedHeight = function (target) {
                return target.classList.contains("fixed-height");
            };
            /**
             * Sets an element to indicate it has a fixed height.
             */
            BaseLayoutProvider.prototype.setFixedHeight = function (target) {
                target.classList.add("fixed-height");
            };
            /**
             * Removes the fixed height status for a child element.
             */
            BaseLayoutProvider.prototype.removeFixedHeight = function (target) {
                target.classList.remove("fixed-height");
            };
            /**
             * Indicates if an element is set to use a fixed increasing height.
             */
            BaseLayoutProvider.prototype.isFixedIncreasingHeight = function (target) {
                return target.classList.contains("fixed-increasing-height");
            };
            /**
             * Sets an element to indicate it has a fixed increasing height.
             */
            BaseLayoutProvider.prototype.setFixedIncreasingHeight = function (target) {
                target.classList.add("fixed-increasing-height");
            };
            /**
             * Removes the fixed-increasing-height status for a child element.
             */
            BaseLayoutProvider.prototype.removeFixedIncreasingHeight = function (target) {
                target.classList.remove("fixed-increasing-height");
            };
            /**
             * Removes the scope marker class from target element
             * @internal
             */
            BaseLayoutProvider.prototype.removeScopeMarker = function (target) {
                target.classList.remove($dyn.layout.ScopeMarker);
            };
            BaseLayoutProvider.prototype.apply = function (target) { };
            return BaseLayoutProvider;
        }());
        layout.provider = new BaseLayoutProvider();
        /**
         * Flexbox layout provider
         * @internal
         */
        // tslint:disable-next-line:class-name
        var css3flexbox = /** @class */ (function (_super) {
            __extends(css3flexbox, _super);
            // TODO Remove _unusedBaseProvider parameter
            function css3flexbox(_unusedBaseProvider) {
                return _super.call(this, $dyn.layout.Providers.css3flexbox) || this;
            }
            return css3flexbox;
        }(BaseLayoutProvider));
        layout.css3flexbox = css3flexbox;
        /**
         * ms-grid layout provider
         * @internal
         */
        // tslint:disable-next-line:class-name
        var css3grid = /** @class */ (function (_super) {
            __extends(css3grid, _super);
            // TODO Remove _unusedBaseProvider parameter
            function css3grid(_unusedBaseProvider) {
                return _super.call(this, $dyn.layout.Providers.css3grid) || this;
            }
            css3grid.prototype.apply = function (target) {
                this.updateColumnsRows(target);
            };
            css3grid.prototype.updateColumnsRows = function (parent) {
                if (!parent || !parent.dynHasArranged) {
                    return;
                }
                var mainAxisFillAttribute = "";
                var crossAxisFillAttribute = "";
                var mainAxisDefinitionAttribute = "";
                var mainAxisAttribute = "";
                var crossAxisDefinitionAttribute = "";
                var crossAxisAttribute = "";
                var mainAxisMinAttribute = "";
                var mainAxisMinProperty;
                if (layout.provider.isHorizontal(parent)) {
                    mainAxisFillAttribute = "fill-width";
                    crossAxisFillAttribute = "fill-height";
                    mainAxisDefinitionAttribute = "msGridColumns"; // "-ms-grid-columns";
                    mainAxisAttribute = "msGridColumn"; // "-ms-grid-column";
                    crossAxisDefinitionAttribute = "msGridRows"; // "-ms-grid-rows";
                    crossAxisAttribute = "msGridRow"; // "-ms-grid-row";
                    mainAxisMinAttribute = "min-width";
                    mainAxisMinProperty = "dynMinFlexWidth";
                }
                else {
                    mainAxisFillAttribute = "fill-height";
                    crossAxisFillAttribute = "fill-width";
                    mainAxisDefinitionAttribute = "msGridRows"; // "-ms-grid-rows";
                    mainAxisAttribute = "msGridRow"; // "-ms-grid-row";
                    crossAxisDefinitionAttribute = "msGridColumns"; // "-ms-grid-columns";
                    crossAxisAttribute = "msGridColumn"; // "-ms-grid-column";
                    mainAxisMinAttribute = "min-height";
                    mainAxisMinProperty = "dynMinFlexHeight";
                }
                var crossAxisAuto = false;
                var crossAxisFill = false;
                var mainAxisDefinitionString = parent.classList.contains("layout-right") ? "1fr" : ""; // In right alignments an extra column is prepended that fills all space to the left.
                var currentIndex = parent.classList.contains("layout-right") ? 2 : 1; // In right alignments an extra column is prepended that fills all space to the left.
                $(parent)
                    .children()
                    .each(function (index, childElement) {
                    var childObject = $(childElement);
                    var dynLastVisible = childElement.getAttribute("data-dyn-lastvisible");
                    if (dynLastVisible != "false" && !childElement.classList.contains("layout-ignore")) {
                        crossAxisFill = crossAxisFill || childElement.classList.contains(crossAxisFillAttribute);
                        crossAxisAuto = crossAxisAuto || !childElement.classList.contains(crossAxisFillAttribute);
                        var defaultMinSize = "min-content";
                        var tempMinMax = " minmax({0}, max-content)";
                        var tempDynMinProp = void 0;
                        var cachedDynMinSize = $(childElement).data(mainAxisMinProperty);
                        if (cachedDynMinSize) {
                            // The size was cached on the element, so we should use that.
                            // Needed for fixed-increasing-height/fixed-increasing-width containers
                            tempDynMinProp = cachedDynMinSize;
                        }
                        else {
                            var dynMinSizingInfo = childElement[mainAxisMinProperty];
                            if (dynMinSizingInfo && childElement.classList.contains(mainAxisFillAttribute)) {
                                // Sizing info will either be a function or a string value. If a function, we will call it to retrieve the min-height/width for this container
                                // Only use the min sizing function if the element is fill(width or height), otherwise, min-content should be used.
                                if (typeof dynMinSizingInfo.minSizeFunction == "function") {
                                    tempDynMinProp = dynMinSizingInfo.minSizeFunction(dynMinSizingInfo.cssClassArgument, childElement);
                                }
                                else {
                                    tempDynMinProp = "" + dynMinSizingInfo;
                                }
                            }
                        }
                        if (childElement.classList.contains(mainAxisFillAttribute)) {
                            defaultMinSize = "0px";
                            tempMinMax = " minmax({0}, 1fr)";
                        }
                        else {
                            if (tempDynMinProp == "0px" || !tempDynMinProp) {
                                tempDynMinProp = "min-content";
                            }
                        }
                        mainAxisDefinitionString += $dyn.format(tempMinMax, tempDynMinProp ? tempDynMinProp : defaultMinSize);
                        childElement.style[mainAxisAttribute] = currentIndex.toString();
                        childElement.style[crossAxisAttribute] = "";
                        currentIndex++;
                    }
                });
                parent.style[mainAxisDefinitionAttribute] = mainAxisDefinitionString;
                parent.style[crossAxisDefinitionAttribute] = "";
                if (crossAxisAuto && crossAxisFill) {
                    parent.classList.add("grid-crossaxis-mixed");
                    parent.classList.remove("grid-crossaxis-fill");
                }
                else if (crossAxisFill) {
                    parent.classList.add("grid-crossaxis-fill");
                    parent.classList.remove("grid-crossaxis-mixed");
                }
                else {
                    parent.classList.remove("grid-crossaxis-fill");
                    parent.classList.remove("grid-crossaxis-mixed");
                }
            };
            return css3grid;
        }(BaseLayoutProvider));
        layout.css3grid = css3grid;
    })(layout = $dyn.layout || ($dyn.layout = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=html-binding-layout.js.map
